import { curry, pipe, prop, filter, forEach } from "ramda";
import tc from "common/common/tcHelpers";

angular
  .module("ticketco/common/arena")
  .directive("arenaSelected", arenaSelected);

var removeClassSelected = tc.dom.removeClass("__selected");
var addClassSelected = tc.dom.addClass("__selected");

function arenaSelected($parse) {
  return {
    require: "tcArena",
    link: function link(scope, elem, attrs, ctrl) {
      var promocode = attrs.promocode;
      var checkIfSelectionChanged = function () {
        return $parse(attrs.arenaSelected)(scope);
      };

      var changeSectionUrl = curry(function (params, x) {
        var baseUrl =
          tc.dom.getAttr("xlink:href", x).split(new RegExp("[?&]", "g"))[0] +
          "?";
        var urlSegments = $.param(filter(Boolean, params));
        return baseUrl + urlSegments;
      });

      var selectionChangeHandler = function (selectedSections) {
        var activeItemType = scope.$eval(attrs.activeItemType);

        if (selectedSections?.length > 0) {
          elem[0].classList.add("__selecting");
        } else {
          elem[0].classList.remove("__selecting");
        }

        // Remove '__selected' class from all sections
        // Map section links adding promocode
        pipe(
          ctrl.$getSections,
          ctrl.mapSectionLinks(
            changeSectionUrl({
              // Always try add promocode
              promocode: promocode,
            })
          ),
          forEach(removeClassSelected)
        )();

        // Add '__selected' class to some sections
        // Add promocode, item_type_id if exist
        forEach(
          pipe(
            tc.dom.attrEq("tc:name"),
            ctrl.$getSections,
            ctrl.mapSectionLinks(
              changeSectionUrl({
                promocode: promocode,
                item_type_id: activeItemType,
              })
            ),
            forEach(addClassSelected)
          )
        )(selectedSections || []);
      };

      scope.$watch(checkIfSelectionChanged, selectionChangeHandler);
    },
  };
}
